import UnavailablesModel from '../models/UnavailablesModel';
import NaApi from '../utils/NaApi';

export default class UnavailablesCollection extends Backbone.Collection {
  constructor(options) {
    super(options);

    this.model = UnavailablesModel;
  }

  url() {
    return (
      appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
      + appConstants.ApiPaths.API_VERSION_PATH
      + appConstants.EndPoints.UNAVAILABLES_PATH
    );
  }

  parse(data) {
    return data.unavailables ? data.unavailables : data;
  }

  dispatchCallback(payload) {
    const { actionType } = payload;
    const { ActionTypes } = appConstants;

    switch (actionType) {
      case ActionTypes.GET_UNAVAILABLES:
        Utils.setMakeshiftTokenHeader();
        UnavailablesStore.fetch({
          url:
            appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
            + appConstants.ApiPaths.API_VERSION_PATH
            + appConstants.EndPoints.UNAVAILABLES_PATH,
          type: 'GET',
          data: payload.postData,
          success: UnavailablesStore.onUnavailablesHandler,
          error: UnavailablesStore.onUnavailablesError,
        });
        break;

      case ActionTypes.CREATE_UNAVAILABLE:
        Utils.setMakeshiftTokenHeader();
        const request = payload.postData;
        const requestURL = appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
          + appConstants.ApiPaths.API_VERSION_PATH
          + appConstants.EndPoints.UNAVAILABLE_REQUESTS_PATH;
        const unavailModel = new UnavailablesModel(payload.postData);
        const allUnavailables = UnavailablesStore.getAllUnavailables();

        UnavailablesStore.create(unavailModel, {
          patch: true,
          silent: true,
          wait: true,
          url: requestURL,
          success: UnavailablesStore.onUnavailablesCreateHandler,
          error: UnavailablesStore.onUnavailablesCreateError,
        });
        break;
      case ActionTypes.CANCEL_TIMEOFF_REQUEST:
        Utils.setMakeshiftTokenHeader();
        const cancelRequest = payload.postData;
        const cancelURL = `${appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
          + appConstants.ApiPaths.API_VERSION_PATH
          + appConstants.EndPoints.UNAVAILABLE_REQUESTS_PATH}/${
          cancelRequest[Utils.getEndpointParam('TIMEOFF_REQUEST_ID')]
        }`;
        const unavailable_store = UnavailablesStore.get(cancelRequest.id);
        unavailable_store.destroy({
          wait: true,
          url: cancelURL,
          success: UnavailablesStore.onCancelRequestSuccess,
          error: UnavailablesStore.onCancelRequestError,
        });
        break;

      case ActionTypes.DECLARE_NA:
        NaApi.declare({
          userId: payload.postData.user_id,
          unavailableTypeId: payload.postData.unavailable_type_id,
          date: payload.postData.date,
          declaringDepartmentId: payload.postData.declaring_department_id,
        }).then((result) => {
          if (result.ok) {
            UnavailablesStore.trigger('unavailables:na:create:success', result);
          } else {
            UnavailablesStore.trigger('unavailables:na:create:error', result);
          }
        });
        break;

      case ActionTypes.REMOVE_NA:
        NaApi.selfRemove(payload.postData.id).then((result) => {
          if (result.ok) {
            UnavailablesStore.trigger('unavailables:na:remove:success', payload.postData.id);
          } else {
            UnavailablesStore.trigger('unavailables:na:remove:error', result, payload.postData.id);
          }
        });
        break;

      default:
        break;
    }
  }
}
